export default "__VITE_ASSET__piNiO8iP__"